import { render } from "./GraphWidgetParams.vue?vue&type=template&id=b8c064ec"
import script from "./GraphWidgetParams.vue?vue&type=script&lang=js"
export * from "./GraphWidgetParams.vue?vue&type=script&lang=js"
script.render = render

export default script